import { Table } from '@mui/material';
import styles from './ForetagTable.module.css';

interface ForetagTableProps {
  className?: string;
}

export const ForetagTable: React.FC<ForetagTableProps> = ({
  children,
  className,
}) => (
  <Table className={`${styles.foretagTable} ${className ? className : ''}`}>
    {children}
  </Table>
);
